import React, { Component } from "react";
import axios from "../../axios";
import * as url from "../../utils/url";
import Plot from "../../utils/customPlotly";
import moment from "moment";

class UniqueActionActivity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      percent: null,
      actionCount: this.props.actionCount,
      isAllEOPage: this.props.eo_id == null ? true : false,
      loading: false,
    };

    //  console.log(this.props)
  }

  componentDidUpdate(prevProps) {
    let { actionCount } = this.state;

    // Typical usage (don't forget to compare props):
    if (this.props.actionCount !== prevProps.actionCount) {
      this.getActionStats();
    }
  }

  componentDidMount() {
    this.getActionStats();
  }

  getActionStats = () => {
    // console.log('called!')
    let params = {
      enterpriseId: this.props.eo_id,
    };
    this.setState({ loading: true });

    axios
      .get(url.getUniqueActionActivity, {
        params: params,
      })
      .then((result) => {
        // console.log('act_unique---',  result)
        let percent = result.data.data;

        this.setState({ percent, loading: false });
      })
      .catch((err) => {
        this.setState({ loading: false });
      });
  };

  render() {
    let { percent, isAllEOPage, loading } = this.state;
    // console.log(this.props)
    if (percent) {
      return (
        <span>
          <div className="enterpriseObjStatInt">{percent.toFixed(0)}<span>%</span></div>
          
        </span>
      );
    } else if (loading) {
      return (
        <div >
          Loading...
        </div>
      );
    } else if (!percent) {
      return (
        <span>
          <div className={isAllEOPage ? "" : "actionStatsNA"}> No tasks </div>
          <p className="actionStatsNAsubtitle"> assigned </p>
        </span>
      );
    } else {
      return (
        <div >
          Loading...
        </div>
      );
    }
  }
}

export default UniqueActionActivity;
